import { useAuth0 } from '@equipmentshare/auth0-react'
import { useAuthenticatedUser } from '../../../hooks/useAuthenticatedUser'
import { AssigneeOption, toCurrentUserOption } from './assigneeOptions'

/**
 * The signed-in person, shaped as an assignee the pick order dialog can offer.
 *
 * A pick order is nearly always created by the person about to walk the floor,
 * so this is the default the dialog starts from. Null when the token carries no
 * `es_user_id` — the assignee is optional, so the field simply starts empty.
 */
export function useCurrentAssignee(): AssigneeOption | null {
	const { id } = useAuthenticatedUser()
	const { user } = useAuth0()

	return toCurrentUserOption( id, {
		name: user?.name,
		givenName: user?.given_name,
		familyName: user?.family_name,
		email: user?.email,
	} )
}
